var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "98EAA022-FA29-4D12-A21E-91632EB9C82A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selling->-Compare-Grain-Handling-solutions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Learning-default",
    transform: "translate(-655.000000, -605.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(635.000000, 585.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph-icon",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,12 C23.5,18.351 18.351,23.5 12,23.5 C5.649,23.5 0.5,18.351 0.5,12 C0.5,5.649 5.649,0.5 12,0.5 C18.351,0.5 23.5,5.649 23.5,12 Z",
    id: "Stroke-1",
    stroke: "#006F44",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 10.5332,
    x2: 12,
    y2: 16.5332,
    id: "Stroke-3",
    stroke: "#006F44",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,7.6668 C11.3,7.2798 11.613,6.9668 12,6.9668 C12.387,6.9668 12.7,7.2798 12.7,7.6668 C12.7,8.0538 12.387,8.3668 12,8.3668 C11.613,8.3668 11.3,8.0538 11.3,7.6668",
    id: "Fill-5",
    fill: "#006F44"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.25f732aa801bdfa7c9fbfffc0fc9e04b.svg";
export { ForwardRef as ReactComponent };